import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../data/site";

const cols = [
  {
    title: "Products",
    links: [
      ["Steam Sterilizer SN250", "/products/sn250"],
      ["Steam Sterilizer SD420", "/products/sd420"],
      ["Plasma Sterilizer PN110", "/products/pn110"],
      ["Washer-Disinfector WD450", "/products/wd450"],
    ],
  },
  {
    title: "Solutions",
    links: [
      ["Medical Waste Treatment", "/solutions/medical-waste-treatment"],
      ["Sterilization Systems", "/solutions/sterilization-systems"],
      ["Integrated Waste Processing", "/solutions/integrated-waste-processing"],
      ["Industrial Solutions", "/solutions/industrial-solutions"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/about"],
      ["Projects", "/projects"],
      ["Blog", "/blog"],
      ["Videos", "/videos"],
      ["News", "/news"],
      ["Contact", "/contact"],
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Logo light />
            <p className="mt-6 text-brand-200 text-sm leading-relaxed max-w-xs">
              STERILTRON engineers advanced medical waste treatment, sterilization and
              industrial processing systems for reliable operation worldwide.
            </p>
            <div className="mt-8 space-y-3 text-sm">
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 text-brand-100 hover:text-white transition-colors">
                <Mail size={16} /> {CONTACT.email}
              </a>
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 text-brand-100 hover:text-white transition-colors">
                <Phone size={16} /> {CONTACT.phone}
              </a>
              <span className="flex items-start gap-3 text-brand-100">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" /> <span>{CONTACT.address}, {CONTACT.city}</span>
              </span>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <h4 className="text-xs uppercase tracking-widest text-brand-300 font-semibold mb-5">{c.title}</h4>
                <ul className="space-y-3">
                  {c.links.map(([label, to]) => (
                    <li key={label}>
                      <Link
                        to={to}
                        data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                        className="text-sm text-brand-100 hover:text-white transition-colors"
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10">
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="group inline-flex items-center gap-3 font-heading text-3xl md:text-5xl font-bold tracking-tight hover:text-brand-200 transition-colors"
          >
            Let's build a cleaner future
            <ArrowUpRight className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" size={40} />
          </Link>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-brand-300">
          <p data-testid="footer-copyright">© 2026 STERILTRON. All rights reserved. — steriltron.com</p>
          <div className="flex flex-wrap gap-6">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-white transition-colors">Cookie Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
